module.exports = __webpack_public_path__ + "img/agentBanner.44f6df06.png";